var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCraigslistScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f609f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#551a8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2d1a82"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,73.59625c13.01099,0,23.59625-10.58527,23.59625-23.59625s-10.58527-23.59625-23.59625-23.59625-23.59625,10.58527-23.59625,23.59625,10.58527,23.59625,23.59625,23.59625ZM52.12671,55.13428l9.95038,9.9505c-2.79126,2.23926-6.20959,3.72345-9.95038,4.13477v-14.08527ZM47.87329,69.21954c-3.74078-.41132-7.15912-1.89551-9.95038-4.13477l9.95038-9.9505v14.08527ZM69.34283,50c0,4.56793-1.60028,8.7641-4.25806,12.07709l-12.95807-12.95795v-18.33868c9.66785,1.06311,17.21613,9.27325,17.21613,19.21954ZM47.87329,30.78046v18.33868l-12.95807,12.95795c-2.65778-3.31299-4.25806-7.50916-4.25806-12.07709,0-9.94629,7.54828-18.15643,17.21613-19.21954Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCraigslistScraper);
export default __webpack_public_path__ + "static/media/craigslist-scraper.18e83695f1a22eb753917753461a855a.svg";
export { ForwardRef as ReactComponent };